export default {
      id: "search-normal-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#search-normal",
      toString: function () {
        return this.url;
      }
    }